import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/app/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isLoading", "visibleColumns", "extraColumns", "tasks"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AppstoreOutlined, BlockOutlined, ProjectOutlined, UserOutlined, UserSwitchOutlined, WarningOutlined } from '@ant-design/icons';
import { Avatar, Badge, Space, Table, Tag, Tooltip } from 'antd';
import { SortDir, TaskIncidenceState } from 'core/client';
import { getCompanyStore } from 'core/modules/companies/company.store';
import { getLabelStore } from 'core/modules/labels/label.store';
import { getMediaStore } from 'core/modules/media/media.store';
import { TaskType } from 'core/modules/tasks/task.interface';
import { getTaskSearchesStore } from 'core/modules/tasks/task-search.store';
import { getUserStore } from 'core/modules/users/user.store';
import { getZoneStore } from 'core/modules/zones/zone.store';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DateFromNow } from 'src/components/DateFromNow';
import { TaskChassisNumberTag } from 'src/components/Tasks/ChassisNumberTag';
import { TaskClientTag } from 'src/components/Tasks/ClientTag';
import { TaskDeadline } from 'src/components/Tasks/Deadline';
import { TaskLabels } from 'src/components/Tasks/Labels';
import { TaskPlateNumberTag } from 'src/components/Tasks/PlateNumberTag';
import { TaskReferenceView } from 'src/components/Tasks/Reference';
import { TaskTypeTag } from 'src/components/Tasks/TypeTag';
import { TaskZoneTag } from 'src/components/Tasks/ZoneTag';
import { TaskStateIcon } from 'src/types/task.types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function getColumnSortOrder(search, name) {
  var _search$sort;

  if (((_search$sort = search.sort) === null || _search$sort === void 0 ? void 0 : _search$sort.sortBy) === name) {
    var _search$sort2;

    return ((_search$sort2 = search.sort) === null || _search$sort2 === void 0 ? void 0 : _search$sort2.sortDir) === SortDir.Asc ? 'ascend' : 'descend';
  }
}

export var TasksTable = function TasksTable(_ref) {
  var isLoading = _ref.isLoading,
      visibleColumns = _ref.visibleColumns,
      extraColumns = _ref.extraColumns,
      tasks = _ref.tasks,
      tableProps = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getMediaStore = getMediaStore(),
      media = _getMediaStore.media,
      getUserMediaSrc = _getMediaStore.getUserMediaSrc,
      getCompanyMediaSrc = _getMediaStore.getCompanyMediaSrc;

  var _getCompanyStore = getCompanyStore(),
      companies = _getCompanyStore.companies;

  var _getUserStore = getUserStore(),
      users = _getUserStore.users;

  var _getLabelStore = getLabelStore(),
      labels = _getLabelStore.labels;

  var _getZoneStore = getZoneStore(),
      zones = _getZoneStore.zones;

  var _getTaskSearchesStore = getTaskSearchesStore(),
      localSearch = _getTaskSearchesStore.localSearch;

  var showDetailsColumn = useMemo(function () {
    return visibleColumns.reportZone || visibleColumns.reportIsFraud || visibleColumns.homologationChassisNumber || visibleColumns.homologationPlateNumber || visibleColumns.homologationClient || visibleColumns.recognitionChassisNumber || visibleColumns.recognitionPlateNumber || visibleColumns.recognitionClient;
  }, [visibleColumns]);
  var columns = useMemo(function () {
    return [visibleColumns.type && {
      key: 'type',
      title: /*#__PURE__*/_jsx(BlockOutlined, {}),
      width: 40,
      dataIndex: 'type',
      // eslint-disable-next-line react/display-name
      render: function render(type) {
        return /*#__PURE__*/_jsx(TaskTypeTag, {
          type: type,
          withTooltip: true
        });
      }
    }, visibleColumns.state && {
      key: 'state',
      title: /*#__PURE__*/_jsx(ProjectOutlined, {}),
      width: 40,
      dataIndex: 'state',
      // eslint-disable-next-line react/display-name
      render: function render(state) {
        return /*#__PURE__*/_jsx(Tooltip, {
          title: t("tasks.state.".concat(state)),
          children: /*#__PURE__*/_jsx("span", {
            className: "state state-".concat(state),
            children: TaskStateIcon[state]
          })
        });
      }
    }, visibleColumns.incidences && {
      key: 'incidences',
      title: /*#__PURE__*/_jsx(WarningOutlined, {}),
      width: 40,
      // eslint-disable-next-line react/display-name
      render: function render(task) {
        return /*#__PURE__*/_jsx(Badge, {
          count: task.incidences.filter(function (incidence) {
            return incidence.state === TaskIncidenceState.Pending;
          }).length
        });
      }
    }, visibleColumns.company && {
      key: 'company',
      title: /*#__PURE__*/_jsx(AppstoreOutlined, {}),
      width: 40,
      dataIndex: ['content', 'company'],
      // eslint-disable-next-line react/display-name
      render: function render(company) {
        return company && /*#__PURE__*/_jsx(Tooltip, {
          title: "".concat(t('form.task.company.label'), " ").concat(company.name),
          children: /*#__PURE__*/_jsx(Avatar, {
            src: getCompanyMediaSrc(company.id),
            icon: /*#__PURE__*/_jsx(AppstoreOutlined, {}),
            size: 24
          })
        });
      }
    }, visibleColumns.deadline && {
      key: 'deadline',
      width: 160,
      title: t('tasksList.columns.deadline'),
      dataIndex: 'deadline',
      // eslint-disable-next-line react/display-name
      render: function render(deadline) {
        return /*#__PURE__*/_jsx(TaskDeadline, {
          deadline: deadline
        });
      },
      sortOrder: getColumnSortOrder(localSearch, 'deadline')
    }, visibleColumns.assignee && {
      key: 'assignee',
      title: /*#__PURE__*/_jsx(UserOutlined, {}),
      width: 40,
      dataIndex: 'assignedTo',
      // eslint-disable-next-line react/display-name
      render: function render(assignedTo) {
        return assignedTo && /*#__PURE__*/_jsx(Tooltip, {
          title: "Asignado a ".concat(assignedTo.name, " <").concat(assignedTo.email, ">"),
          children: /*#__PURE__*/_jsx(Avatar, {
            src: getUserMediaSrc(assignedTo.id),
            icon: /*#__PURE__*/_jsx(UserOutlined, {}),
            size: 24
          })
        });
      }
    }, visibleColumns.reviewer && {
      key: 'reviewer',
      title: /*#__PURE__*/_jsx(UserSwitchOutlined, {}),
      width: 40,
      dataIndex: 'reviewer',
      // eslint-disable-next-line react/display-name
      render: function render(reviewer) {
        return reviewer && /*#__PURE__*/_jsx(Tooltip, {
          title: "Revisor ".concat(reviewer.name, " <").concat(reviewer.email, ">"),
          children: /*#__PURE__*/_jsx(Avatar, {
            src: getUserMediaSrc(reviewer.id),
            icon: /*#__PURE__*/_jsx(UserOutlined, {}),
            size: 24
          })
        });
      }
    }, visibleColumns.title && {
      key: 'title',
      ellipsis: true,
      title: t('tasksList.columns.title'),
      dataIndex: 'title'
    }, visibleColumns.description && {
      key: 'description',
      ellipsis: true,
      title: t('tasksList.columns.description'),
      dataIndex: 'description'
    }, // Content (depends on the type)
    visibleColumns.reference && {
      key: '',
      title: t('form.task.reference.label'),
      ellipsis: true,
      width: 220,
      render: function render(task) {
        if ((task === null || task === void 0 ? void 0 : task.content.type) === TaskType.Report) {
          return /*#__PURE__*/_jsx(TaskReferenceView, {
            task: task
          });
        }

        if ((task === null || task === void 0 ? void 0 : task.content.type) === TaskType.Homologation) {
          return /*#__PURE__*/_jsx(TaskReferenceView, {
            task: task
          });
        }

        if ((task === null || task === void 0 ? void 0 : task.content.type) === TaskType.Recognition) {
          return /*#__PURE__*/_jsx(TaskReferenceView, {
            task: task
          });
        }

        return;
      }
    }, showDetailsColumn && {
      key: 'details',
      title: t('tasksList.columns.details'),
      ellipsis: true,
      // eslint-disable-next-line react/display-name
      render: function render(task) {
        if ((task === null || task === void 0 ? void 0 : task.content.type) === TaskType.Report) {
          return /*#__PURE__*/_jsxs(Space, {
            children: [visibleColumns.reportZone && /*#__PURE__*/_jsx(TaskZoneTag, {
              task: task
            }, "zone"), visibleColumns.reportIsFraud && task.content.isFraud && /*#__PURE__*/_jsx(Tooltip, {
              title: t('task.isFraud'),
              children: /*#__PURE__*/_jsx(WarningOutlined, {})
            })]
          });
        }

        if ((task === null || task === void 0 ? void 0 : task.content.type) === TaskType.Homologation) {
          return /*#__PURE__*/_jsxs(Space, {
            size: 0,
            className: "details-column",
            children: [visibleColumns.homologationPlateNumber && /*#__PURE__*/_jsx(TaskPlateNumberTag, {
              task: task
            }, "plateNumber"), visibleColumns.homologationChassisNumber && /*#__PURE__*/_jsx(TaskChassisNumberTag, {
              task: task
            }, "chassisNumber"), visibleColumns.homologationClient && /*#__PURE__*/_jsx(TaskClientTag, {
              task: task
            }, "client")]
          });
        }

        if ((task === null || task === void 0 ? void 0 : task.content.type) === TaskType.Recognition) {
          return /*#__PURE__*/_jsxs(Space, {
            size: 0,
            className: "details-column",
            children: [visibleColumns.recognitionPlateNumber && /*#__PURE__*/_jsx(TaskPlateNumberTag, {
              task: task
            }, "plateNumber"), visibleColumns.recognitionChassisNumber && /*#__PURE__*/_jsx(TaskChassisNumberTag, {
              task: task
            }, "chassisNumber"), visibleColumns.recognitionClient && /*#__PURE__*/_jsx(TaskClientTag, {
              task: task
            }, "client")]
          });
        }
      }
    }, visibleColumns.labels && {
      key: 'labels',
      title: t('tasksList.columns.labels'),
      width: 120,
      dataIndex: 'labels',
      // eslint-disable-next-line react/display-name
      render: function render(labels) {
        return /*#__PURE__*/_jsx(TaskLabels, {
          labels: labels,
          max: 3
        });
      }
    }, visibleColumns.documents && {
      key: 'documents',
      title: t('tasksList.columns.documents'),
      width: 125,
      // eslint-disable-next-line react/display-name
      render: function render(task) {
        return /*#__PURE__*/_jsx(Tooltip, {
          title: t('tasksList.documentsTooltip', task),
          placement: "left",
          children: /*#__PURE__*/_jsxs(Space, {
            size: 0,
            children: [/*#__PURE__*/_jsx(Tag, {
              color: task.numDocuments > 0 ? 'success' : 'default',
              children: task.numDocuments
            }), /*#__PURE__*/_jsx(Tag, {
              color: task.numPhotos > 0 ? 'success' : 'default',
              children: task.numPhotos
            }), /*#__PURE__*/_jsx(Tag, {
              color: task.numReports > 0 ? 'success' : 'default',
              children: task.numReports
            })]
          })
        });
      }
    }, visibleColumns.comments && {
      key: 'comments',
      title: t('tasksList.columns.comments'),
      width: 125,
      // eslint-disable-next-line react/display-name
      render: function render(task) {
        return /*#__PURE__*/_jsx(Tooltip, {
          title: t('tasksList.commentsTooltip', {
            numComments: task.comments.length
          }),
          children: /*#__PURE__*/_jsx(Space, {
            size: 0,
            children: /*#__PURE__*/_jsx(Tag, {
              color: task.comments.length > 0 ? 'success' : 'default',
              children: task.comments.length
            })
          })
        });
      }
    }, visibleColumns.createdAt && {
      key: 'createdAt',
      title: t('tasksList.columns.createdAt'),
      width: 150,
      // eslint-disable-next-line react/display-name
      render: function render(task) {
        return /*#__PURE__*/_jsx(DateFromNow, {
          date: task.createdAt
        });
      }
    }, visibleColumns.updatedAt && {
      key: 'updatedAt',
      title: t('tasksList.columns.updatedAt'),
      width: 150,
      // eslint-disable-next-line react/display-name
      render: function render(task) {
        return /*#__PURE__*/_jsx(DateFromNow, {
          date: task.updatedAt
        });
      }
    }, visibleColumns.closedAt && {
      key: 'createdAt',
      title: t('tasksList.columns.closedAt'),
      width: 150,
      // eslint-disable-next-line react/display-name
      render: function render(task) {
        return /*#__PURE__*/_jsx(DateFromNow, {
          date: task.closedAt
        });
      }
    }].concat(_toConsumableArray(extraColumns !== null && extraColumns !== void 0 ? extraColumns : [])).filter(Boolean);
  }, [isLoading, companies, users, labels, zones, media, extraColumns]);
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Table, _objectSpread({
      loading: isLoading,
      scroll: {
        x: true
      },
      dataSource: tasks,
      columns: columns,
      rowKey: "id"
    }, tableProps))
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Table__Container",
  componentId: "sc-1cu4stu-0"
})([""]);